import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartService from "components/request-document/hooks/useSmartService";
import { useFormik } from "formik";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import { useDispatch } from "react-redux";
import { addSmartForm } from "redux/modules/visaForm";
import * as yup from "yup";

export default function useSurayForm() {
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();

  const { draftId, smartform } = useSmartForm();

  const { smartServiceId } = useSmartService();
  const { personalId } = usePersonalDetail();

  const validationSchema = yup.object({
    acceptSurvey: yup.bool(),
    // survey: yup.object().when("acceptSurvey", {
    //   is: (value) => value === true.valueOf,
    //   then: yup.object({
    //     surveyID: null,
    //     shareholdingThaiPersons: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     shareholdingForeigners: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     thaiEmployees: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     foreignersEmployees: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     annualExpBaht: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     annualExptTotal: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     employeesMaster: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //     employeesUniversity: yup
    //       .number()
    //       .nullable(true)
    //       .required("Field is required"),
    //   }),
    //   otherwise: yup.object(),
    // }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      acceptSurvey: null,
      survey: {
        surveyID: get(smartform, "survey.surveyID", null),
        shareholdingThaiPersons: get(
          smartform,
          "survey.shareholdingThaiPersons",
          null
        ),
        shareholdingForeigners: get(
          smartform,
          "survey.shareholdingForeigners",
          null
        ),
        thaiEmployees: get(smartform, "survey.thaiEmployees", null),
        foreignersEmployees: get(smartform, "survey.foreignersEmployees", null),
        annualExpBaht: get(smartform, "survey.annualExpBaht", null),
        annualExptTotal: get(smartform, "survey.annualExptTotal", null),
        employeesMaster: get(smartform, "survey.employeesMaster", null),
        employeesUniversity: get(smartform, "survey.employeesUniversity", null),
      },
    },
    onSubmit: async (values) => {
      showLoading();

      const prepareData = {
        draftId: draftId || null,
        smartserviceId: smartServiceId,
        personalId: personalId,
        survey: values.acceptSurvey === true ? values.survey : null,
        visaissuance: get(smartform, "visaissuance", null),
        detail: [],
      };

      await dispatch(addSmartForm({ data: prepareData }));
    },
  });

  return { formik };
}
